import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

const PieChartComponent = ({ data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      const myChart = echarts.init(chartRef.current);
      const option = {
        color: ["#4F97A3", "#5D8AA8", "#6497B1", "#6A5ACD", "#708090", "#73C2FB", "#7B68EE", "#7DF9FF", "#82CAFF", "#87CEEB",
          "#87CEFA", "#89CFF0", "#8A2BE2", "#8C92AC", "#8FBC8F", "#00BFFF", "#00CED1", "#4682B4", "#483D8B", "#4169E1",
          "#5F9EA0", "#6495ED", "#6A5ACD", "#708090", "#00BFFF", "#1E90FF", "#20B2AA", "#4682B4", "#4682B4", "#483D8B",
          "#00CED1", "#5F9EA0", "#6495ED", "#663399", "#66CDAA", "#696969", "#6A5ACD", "#6B8E23", "#708090", "#778899",
          "#7B68EE", "#7CFC00", "#7FFF00", "#7FFFD4", "#800000", "#800080", "#808000", "#808080", "#8470FF", "#87CEEB"
        ],
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center',
          // show: false
        },
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: true,
            padAngle: 5,
            itemStyle: {
              borderRadius: 10
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 32,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: data
          }
        ]
      };
      
      myChart.setOption(option);
      window.addEventListener('resize', myChart.resize);

      return () => {
        window.removeEventListener('resize', myChart.resize);
        myChart.dispose();
      };
    }
  }, [data]);

  return <div ref={chartRef} style={{ width: '100%', height: '100%' }} />;
};

export default PieChartComponent;
